import React from "react";

export default function useRootFontSize(initialFontSize): number {
  const [rootFontSize, setRootFontSize] = React.useState<number>(initialFontSize);

  React.useEffect(() => {
    const htmlEl = document.documentElement;
    if (!htmlEl) return; // Safety (should not happen in browser)

    function syncFontSize() {
      try {
        const size = window.getComputedStyle(htmlEl).fontSize;
        const parsed = parseFloat(size);
        if (!Number.isNaN(parsed)) {
          setRootFontSize(parsed);
        }
      } catch {
        // ignore
      }
    }

    syncFontSize();

    const mutationObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === "attributes" && m.attributeName === "style") {
          syncFontSize();
          break;
        }
      }
    });
    mutationObserver.observe(htmlEl, {
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => {
      mutationObserver.disconnect();
    };
  }, []);

  return rootFontSize;
}
